// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".doc-log-btn[data-v-55e77610]{min-width:87px;color:#fff;background-color:#09e5ab;border:1px solid #09e5ab!important;box-shadow:inset 0 0 0 0 #fff;transition:.7s}.doc-log-btn[data-v-55e77610]:hover{color:#09e5ab!important;background-color:#fff;border:1px solid #09e5ab;box-shadow:inset 0 0 0 50px #fff;transition:.7s}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
